import PastEventPlayback from './PastEvent.Playback';

import styles from './PastEvent.module.scss';

export type PastEventProps = {
  eventCode: string;
  playbackUrl: string;
  disabled?: boolean;
};

const PastEvent = ({ eventCode, playbackUrl, disabled = false }: PastEventProps) => (
  <div className={styles.container}>
    <PastEventPlayback eventCode={eventCode} playbackUrl={playbackUrl} disabled={disabled} />
  </div>
);

export default PastEvent;
